<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="table.data"
      :loading="table.loading"
      :items-per-page="200"
      hide-default-footer
      item-key="id"
      sort-by="category"
      class="elevation-1 group-results">
      <template v-slot:body="{ items }">
        <tr
          v-for="(r, i) in items"
          :key="`category-${i}`">
          <td
            v-for="(k, j) in headers"
            :key="`cell-${j}`"
            :class="j + 1 === headers.length ? 'grey lighten-5' : ''">
            <div v-if="k.value === 'category'" style="min-width:170px">
              <a href="#" @click.prevent="openDetail(r.products, r[k.value])">
                {{ r[k.value] }}
              </a>
            </div>
            <div v-else-if="i + 1 === headers.length" style="min-width:170px; text-align: right">
              <span v-if="r[k.value]">
                {{ r[k.value] | toFixNumber(2) | numberWithComma | prefix('$') }}
              </span>
              <span v-else class="grey--text">
                Sin datos
              </span>
            </div>
            <div v-else style="min-width:170px; text-align: right">
              <span v-if="r[k.value]">
                {{ r[k.value] | toFixNumber(2) | numberWithComma | prefix('$') }}
              </span>
              <span v-else class="grey--text">
                Sin datos
              </span>
            </div>
          </td>
        </tr>
      </template>
      <template v-slot:footer>
        <div class="pa-5" />
      </template>
    </v-data-table>

    <ReportPurchasesByCategoryDetail ref="reportPurchasesByCategoryDetail" />
  </div>
</template>

<script>
import ReportPurchasesByCategoryDetail from '@/components/sidePanels/ReportPurchasesByCategoryDetail'
import { uniq, flattenDeep } from 'lodash'
import { mapGetters } from 'vuex'
export default {
  components: { ReportPurchasesByCategoryDetail },
  props: {
    reports: {
      type: Array,
      required: true,
      default: null
    },
    period: {
      type: String,
      required: true
    },
    dates: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      table: {
        data: [],
        loading: false
      },
      momentPeriods: {
        week: 'isoWeek',
        month: 'month',
        year: 'year'
      }
    }
  },
  async mounted () {
    await this.getFormattedData()
  },
  computed: {
    ...mapGetters(['restaurant', 'areas']),
    area () {
      return this.$route.params.id
    },
    headers () {
      const headers = [ { text: 'Departamento', align: 'start', value: 'category' } ]
      const keys = uniq(flattenDeep(this.table.data.map(k => Object.keys(k))))
      keys.forEach(key => {
        if (key !== 'category' && key !== 'id' && key !== 'products') {
          headers.push({ text: key, value: key, align: 'end', sortable: false })
        }
      })
      return headers
    }
  },
  watch: {
    async dates () {
      await this.getFormattedData()
    }
  },
  methods: {
    async getFormattedData () {
      this.table.loading = true
      try {
        let [ fromDate ] = this.dates
        const purchasesProductsByCategory = await this.$api.get(`/v1/restaurants/${this.restaurant._id}/reports/purchases-products-by-category`, {
          date: this.$moment(fromDate).format('YYYY-MM-DD'),
          type: this.period,
          area: this.area
        })

        const items = []
        for (const purchase of purchasesProductsByCategory) {
          purchase.items.forEach(item => {
            const itemIndex = items.findIndex(i => i.category === item.categoryName)
            const [year, period] = purchase.period.split('-')
            const periodKind = this.momentPeriods[this.period]
            const keyPeriod = period
              ? `${this.$moment()[periodKind](period).startOf(periodKind).format('YYYY-MM-DD')} | ${this.$moment()[periodKind](period).endOf(periodKind).format('YYYY-MM-DD')}`
              : year
            const products = item.products.map(p => ({ ...p, period: keyPeriod }))
            if (itemIndex >= 0) {
              items[itemIndex][keyPeriod] = item.total || 0
              items[itemIndex].products.push(...products)
            } else {
              const purchaseCategory = { category: item.categoryName, id: item.category, products: products }
              purchaseCategory[keyPeriod] = item.total || 0
              items.push(purchaseCategory)
            }
          })
        }
        this.table.data = items
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.table.loading = false
    },
    openDetail (products, category) {
      this.$refs.reportPurchasesByCategoryDetail.open(products, category)
    }
  }
}
</script>
